import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData,deleteData } from '../../services/supportingJournalsServices';
import { Button, Modal, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import { validateFile} from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { isQuillContentEmpty, cleanQuillHtml  } from '../../utils/common';

const modules = {
  toolbar: [
    // Font family and size
    [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

    // Headings
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    // Text styles
    ['bold', 'italic', 'underline', 'strike'],

    // Subscript / Superscript
    [{ 'script': 'sub' }, { 'script': 'super' }],

    // Blockquote and code block
    ['blockquote', 'code-block'],

    // Color and background
    [{ 'color': [] }, { 'background': [] }],

    // Text alignment and direction (RTL)
    [{ 'align': [] }, { 'direction': 'rtl' }],

    // Ordered / bullet list
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    // Indent and outdent
    [{ 'indent': '-1' }, { 'indent': '+1' }],

      ['link'],

    // Clear formatting
    ['clean']
  ]
};
  
const formats = [
  'font', 'size',
  'header',
  'bold', 'italic', 'underline', 'strike',
  'script',
  'blockquote', 'code-block',
  'color', 'background',
  'align', 'direction',
  'list', 'bullet', 'indent',
  'link', 'image', 'video'
];
const Supportingjournals = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); 
  const [data, setData] = useState([]);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setselectedData] = useState(null);
  const [formData, setFormData] = useState({
    id: null,
    sup_alt_img: '',
    sup_title: '',
    sup_desc: '',
    sup_issn: '',
    uploadedfile: null, 
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  


  // Fetch data from API
      const fetchData = useCallback(async () => {
        setLoading(true);
        try {
        const response = await getData();
        setData(response);
        }
        catch (error) { 
          console.error('Error fetching data:', error);
        }
        finally {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      }, []);
  
      useEffect(() => {
        fetchData();
      }, [fetchData]);
  
  // Validate form data
    const validateForm = () => {
    const newErrors = {};
    if (!formData.sup_alt_img) newErrors.sup_alt_img = "Alt Image Name  is required";
    if (!formData.sup_title) newErrors.sup_title = "Journal Title is required";
    if (!formData.sup_issn) newErrors.sup_issn = "Journal ISSN Number is required";
    if (!formData.uploadedfile && formData.uploadedfile === null) {
    if (!errors.uploadedfile) newErrors.uploadedfile = "Journal Image is required";
      }
    if ( isQuillContentEmpty(formData.sup_desc.trim())) newErrors.sup_desc = "Journal Description is required";
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
  }

  
    const handleChange = async (e) => {
      try{
          const { name, value, files } = e.target;
          const file = files?.[0]
            // Create a copy of the current form data
            let updatedData = { ...formData };
            let updatedErrors = { ...errors };
            if (file) {
                const fileType = file.type.includes("image") ? "img" : "pdf";
                const isValid = await validateFile(file, setErrors,name,fileType);
                if (isValid) {
                  updatedData[name] = file;
                  updatedErrors[name] = '';
                }
                else{
                  return ; // Don't update if invalid
                }
          } 
            else{
            updatedData[name] = value;
            if (value) {
            updatedErrors[name] = ''; // Clear error if corrected
          }}
          setFormData(updatedData);
          setErrors(updatedErrors);
        }
        catch (error) {
        console.error("Error in handleChange:", error);
      }
    };

    const handleSubmit = async (e) => { 
      e.preventDefault();
      if (!validateForm()) {
        return
      }
      try{
      const form = new FormData();
      form.append('id', formData.id);
      form.append('sup_alt_img', formData.sup_alt_img);
      form.append('sup_title', formData.sup_title);
      form.append('sup_desc', cleanQuillHtml(formData.sup_desc));        
      form.append('sup_issn', formData.sup_issn);
      form.append('uploadedfile', formData.uploadedfile);
    
      if (modalType === 'add') {
        const result = await addData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Added Successfully!", {
                                      position: 'top-right',
                                      autoClose: 3000,
                                    });
        } else {
          toast.error(result.message ||"Failed to Added data. Please try again.", {position: 'top-right',autoClose: 3000});
        }
      } else if (modalType === 'edit') {
        const result = await updateData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Updated Successfully!", {position: 'top-right', autoClose: 3000});
        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
        }
      }
    }
    catch (error) {
      console.error("Error in handleChange:", error);
    }
    };

    const handleDelete = async () => {
      try{
          if (selectedData) {
            const result = await deleteData(selectedData.id);
            if (result.status === 200) {
              fetchData();
              setShowDeleteConfirmModal(false);
              toast.success("Deleted Successfully!", { position: 'top-right', autoClose: 3000,});
            } else {
              toast.error(result.message ||"Failed to Delete data. Please try again.", {position: 'top-right',});
            }
          }

          }
          catch (error) {
          console.error('Error deleting data:', error);
          }
          
        };

  // Handle change for Quill editor
  const handledescriptionChange = (value) => {
    setErrors((prev) => ({ ...prev, sup_desc: isQuillContentEmpty(value) ? 'Journal Description is required' : '' }));
    setFormData((prev) => ({ ...prev, sup_desc: value }));
  };
  

  const openModal = (type, data = { 
    id: null,
    sup_alt_img: '',
    sup_title: '',
    sup_desc: '',
    sup_issn: '',
    uploadedfile: null, 
   }) => {
    setModalType(type);
    setFormData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openDeleteConfirmModal = (data) => {
    setselectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
    setselectedData(null);
  };
  
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


   // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
        const filtered =  data.filter(
          (data) =>
          data.sup_title.toLowerCase().includes(searchText.toLowerCase())
        );
        const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        return sortedData;
      }, [data, searchText]);
    

  const columns = [
    {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
      },
    {
        name: 'Journal Title',
        selector: (row) => row.sup_title,
        sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
                <div>
                  <Button
                    className="me-2"
                    variant="warning"
                    size="sm"
                    onClick={() => openModal('edit', {
                      id: row.id,
                      uploadedfile: row.sup_img, // File input should be reset
                      sup_alt_img: row.sup_alt_img, 
                      sup_title: row.sup_title, 
                      sup_desc: row.sup_desc, 
                      sup_issn: row.sup_issn,      
                    })}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => openDeleteConfirmModal(row)}
                  >
                    Delete
                  </Button>
                </div>
              ),
    },
  ];

  useEffect(() => {
        const tooltipMap = {
          'ql-bold': 'Bold',
          'ql-italic': 'Italic',
          'ql-underline': 'Underline',
          'ql-strike': 'Strikethrough',
          'ql-script[value="sub"]': 'Subscript',
          'ql-script[value="super"]': 'Superscript',
          'ql-blockquote': 'Blockquote',
          'ql-code-block': 'Code Block',
          'ql-color': 'Text Color',
          'ql-background': 'Background Color',
          'ql-align': 'Align',
          'ql-direction': 'Text Direction',
          'ql-list[value="ordered"]': 'Ordered List',
          'ql-list[value="bullet"]': 'Bullet List',
          'ql-indent[value="-1"]': 'Outdent',
          'ql-indent[value="+1"]': 'Indent',
          'ql-link': 'Insert Link',
          'ql-clean': 'Clear Formatting',
        };
  
      const setTooltips = () => {
        Object.entries(tooltipMap).forEach(([selector, title]) => {
          const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
          if (el && !el.title) {
            el.setAttribute('title', title);
          }
        });
      };
  
      const observer = new MutationObserver((mutations, obs) => {
        const toolbarReady = document.querySelector('.ql-toolbar');
        if (toolbarReady) {
          setTooltips();
          obs.disconnect(); // Stop observing once done
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
  
    return () => observer.disconnect() // Clean up on unmount
    }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Other Pages <b>/ Supporting Journal</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} className="modal-lg" onHide={closeModal} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <div className='row'>
                    <Form.Group className="col-md-6 mb-3">
                            <Form.Label className='form-label-custom'>Journal Title <small className='text-danger'> * </small> </Form.Label>
                            <Form.Control
                                type="text"
                                name="sup_title"
                                value={formData.sup_title}
                                onChange={handleChange}
                                isInvalid = {!!errors.sup_title}
                            />
                    <Form.Control.Feedback type="invalid">{errors.sup_title}</Form.Control.Feedback>

                    </Form.Group>               
                    <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>Journal ISSN Number <small className='text-danger'> * </small></Form.Label>
                    <Form.Control
                        type="text"
                        name="sup_issn"
                        value={formData.sup_issn}
                        onChange={handleChange}
                        isInvalid = {!!errors.sup_issn}
                    />
                    <Form.Control.Feedback type="invalid">{errors.sup_issn}</Form.Control.Feedback>

                    </Form.Group> 
                    <Form.Group className="mb-3">
                    <Form.Label className='form-label-custom'>Journal Description <small className='text-danger'>*</small></Form.Label>
                    <ReactQuill
                        value={formData.sup_desc}
                        onChange={handledescriptionChange}
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        placeholder="Enter description"
                        className={`react-quill-editor ${errors.sup_desc ? 'border border border-1 border-danger rounded' : ''}`}                        
                    />
                      {errors.sup_desc && (
                      <div className="invalid-feedback d-block">
                        {errors.sup_desc}
                      </div>
                    )}
                    </Form.Group>                               
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>
                        Journal Image <small className='text-danger'>*</small> <small className="text-primary"> (Dimension: 226x317 | Size:10kb-100kb)</small>
                        </Form.Label>
                        <Form.Control
                            type="file"
                            name="uploadedfile"
                            onChange={handleChange}
                            isInvalid = {!!errors.uploadedfile}
                             accept="image/*"
                        />
                      <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>
                        
                    </Form.Group>
                    <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>Alt Image Name <small className='text-danger'> * </small></Form.Label>
                    <Form.Control
                        type="text"
                        name="sup_alt_img"
                        value={formData.sup_alt_img}
                        onChange={handleChange}
                        isInvalid = {!!errors.sup_alt_img}
                    />
                      <Form.Control.Feedback type="invalid">{errors.sup_alt_img}</Form.Control.Feedback>
                    </Form.Group>                 
                </div>

                <Modal.Footer className='border-0'>
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {modalType === 'add' ? 'Add' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>
           {/* Delete Confirmation Modal */}
                    <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
                      <Modal.Header closeButton>
                        <Modal.Title>Delete</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p>Are you sure you want to delete this row?</p>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={closeDeleteConfirmModal}>
                          Cancel
                        </Button>
                        <Button variant="danger" onClick={handleDelete}>
                          Yes, Delete
                        </Button>
                      </Modal.Footer>
                    </Modal>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Supportingjournals;